/** Stable DOM ids for genius section scroll targets (not tied to heading copy). */
export const GENIUS_SECTION_IDS = Object.freeze({
  STORIES: "genius-section-stories",
  JOURNEY: "genius-section-journey",
  PARTNER_SCHOOLS: "genius-section-partner-schools",
  FAQS: "genius-section-faqs",
});
